import PosthogService from '~/services/posthog/PosthogService';

export function fireDashboardTodayShiftTabClicked(): void {
  PosthogService.getInstance().track('dental_portal:dashboard:today_shift_tab_clicked');
}
